import { Modal, Table, Row, Col, Button, Form, FormGroup, Input } from 'reactstrap';
import { useContext, useState, useEffect } from 'react';
import { Context as AuthContext } from '../../../contexts/AuthContext';
import ExpirationDatesTypesService from '../../../services/ExpirationDatesTypes';
import { toast } from 'react-toastify';

type ExpirationDatesTypesModalProps = {
  isOpen: boolean;
  toggleModal: (e?: any) => void;
};

const ExpirationDatesTypesModal = ({ isOpen, toggleModal }: ExpirationDatesTypesModalProps) => {
  const { token }: any = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [expirationDatesTypesName, setExpirationDatesTypesName] = useState('');
  const [expirationDatesTypesList, setExpirationDatesTypesList] = useState([] as any[]);

  useEffect(() => {
    if (isOpen) {
      listData();
    }
  }, [isOpen]);

  const listData = async () => {
    try {
      const result = await ExpirationDatesTypesService(token).list();
      setExpirationDatesTypesList(result.data || []);
    } catch (e: any) {
      toast.error(e?.response?.data?.message || 'No Types Found!');
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    try {
      await ExpirationDatesTypesService(token).create({
        name: expirationDatesTypesName,
      });
      toast.success(`Saved successfully!`);
      listData();
      setShowForm(false);
    } catch (e: any) {
      const message = String(e?.response?.data?.message || 'Create error!');
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const deleteSettings = async (e: React.FormEvent, id: string) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    try {
      await ExpirationDatesTypesService(token).delete(id);
      toast.success(`Deleted successfully!`);
      listData();
    } catch (e: any) {
      const message = String(e?.response?.data?.message || 'Delete error!');
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal className="modal-dialog-centered" isOpen={isOpen} toggle={(e: any) => toggleModal(e)}>
        <div className="modal-header pb-1">
          <h5 className="modal-title">Edit Expiration Dates Types</h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={(e) => toggleModal(e)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body pt-0">
          <Table className="align-items-center table-flush" responsive>
            <tbody>
              <tr>
                <th>Title</th>
                <th>Action</th>
              </tr>
              {expirationDatesTypesList?.length === 0 && (
                <tr>
                  <td colSpan={2} className="text-center">
                    Data not found
                  </td>
                </tr>
              )}
              {expirationDatesTypesList.map((s: any) => (
                <tr key={`expirationDatesTypes-modal-${s.id}`}>
                  <td>{s.name}</td>
                  <td>
                    <i
                      className="far fa-trash-alt text-danger"
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => deleteSettings(e, s.id)}
                    ></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Row>
            {!showForm && (
              <Col>
                <Button
                  color="primary"
                  onClick={() => {
                    setShowForm(true);
                  }}
                >
                  <i className="fas fa-plus" />
                  <span>Create New</span>
                </Button>
              </Col>
            )}
            {showForm && (
              <Col>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col lg="12">
                      <FormGroup>
                        <label className="form-control-label">Name</label>
                        <Input onChange={(e) => setExpirationDatesTypesName(e.target.value)} />
                      </FormGroup>
                    </Col>
                    <Col md="6 text-center">
                      <Button color="primary" type="submit" size="lg" style={{ minWidth: '100px' }}>
                        Save
                      </Button>
                    </Col>
                    <Col md="6 text-center">
                      <Button
                        color="secondary"
                        size="lg"
                        style={{ minWidth: '100px' }}
                        onClick={(e) => {
                          e.preventDefault();
                          setShowForm(false);
                        }}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            )}
          </Row>
        </div>
      </Modal>
    </>
  );
};

export default ExpirationDatesTypesModal;
